import {BaseModel} from "../../../../infrastructure/models/base-model";
import {DidomiConfigNoticeContentModel} from "./didomi-config.notice.content-model";

export class DidomiConfigUserBotsModel extends BaseModel {
  get consentRequired(): String {
    return false;
  }

  get types(): Array<String> {
    const types: DidomiConfigNoticeContentModel = ['crawlers', 'performance'];

    return types;
  }

  getDidomiObject() {
    return {
      bots:
        {
          consentRequired: this.consentRequired,
          types: this.types
        }
    }
  }
}
